import React, { useState, useContext } from 'react';
import { Button, DialogActions, Grid, TextField, CircularProgress, IconButton } from '@mui/material';
import styles from './styles.module.css';
import CloseIcon from '@mui/icons-material/Close';
import { AlertMessagesContext } from 'react-alert-messages';
import ExpenseTypeService from 'services/ExpenseTypeService';
import { useTranslation } from 'react-i18next';

export default function ExpenseTypeEditDialog({ expenseType, handleClose, handleSuccess }) {
  const { t: tCommon } = useTranslation('common');
  const { t: tPopup } = useTranslation('popup');

  const [isLoading, setLoading] = useState(false);
  const [data, setData] = useState(expenseType || {});

  const { postAlertMessage } = useContext(AlertMessagesContext);

  const handleActionButton = async () => {
    setLoading(true);
    try {
      const updatedExpenseType = await ExpenseTypeService.updateExpenseType(data.id, data);
      postAlertMessage({ text: tPopup('Expense type updated successfully'), type: 'success' });
      handleSuccess(updatedExpenseType);
    } catch (error) {
      postAlertMessage({ text: error?.message, type: 'failed' });
      handleClose();
    }
    setLoading(false);
  };

  return (
    <>
      <div className={styles.popUp}>
        <div className={styles.contentWrapper}>
          <div className={styles.headSec}>
            <h2 className={styles.editTitle}>{tCommon('Edit Expense Type')}</h2>
            <IconButton onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </div>
          <div className={styles.inputSec}>
            <div>
              <Grid container alignItems="center">
                <Grid item xs={4} sm={4}>
                  <h6 className={styles.tableName}>{tCommon('Name')}</h6>
                </Grid>
                <Grid item sm={8} xs={8}>
                  <TextField
                    label={tCommon('Name')}
                    variant="outlined"
                    size="small"
                    fullWidth
                    type="text"
                    defaultValue={data.name}
                    onChange={(e) => {
                      setData({ ...data, name: e.target.value });
                    }}
                  />
                </Grid>
              </Grid>
            </div>
          </div>
          <div className={styles.footSec}>
            <DialogActions>
              <Button variant="contained" color="secondary" size="small" onClick={handleClose}>
                {tCommon('Close')}
              </Button>
              <Button
                variant="contained"
                color="primary"
                size="small"
                style={{ backgroundColor: '#00a65a' }}
                disabled={!data.name || isLoading}
                onClick={handleActionButton}
              >
                {isLoading ? (
                  <>
                    <CircularProgress size={20} color="inherit" style={{ marginRight: '10px' }} />
                    {tCommon('Updating...')}
                  </>
                ) : (
                  tCommon('Update')
                )}
              </Button>
            </DialogActions>
          </div>
        </div>
      </div>
    </>
  );
}
